<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import DatePickerInput, {
        dateTimeNullable,
    } from '$components/Date/DatePickerInput.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const stayTypeOptions = [
        `Séjour d'affaires`,
        `Vacances en famille`,
        `Escapade romantique`,
        `Séjour économique`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const essentialAmenitiesOptions = [
        `Wi-Fi gratuit`,
        `Piscine`,
        `Restaurant sur place`,
        `Salle de sport`,
        `SPA`,
        `Parking gratuit`,
        `Salle de conférence`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const hotelRatingOptions = [
        `1 étoile`,
        `2 étoiles`,
        `3 étoiles`,
        `4 étoiles`,
        `5 étoiles`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.hotels.stayType}
        class=""
        let:field
        let:id
        label={`Quel type de séjour recherchez-vous ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={stayTypeOptions}
            placeholder="Sélectionnez un type de séjour"
        />
    </Row>

    <Row
        {form}
        field={fields.hotels.essentialAmenities}
        class=""
        let:field
        let:id
        label={`Quelles sont les commodités essentielles pour vous lors de votre séjour à l'hôtel ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={essentialAmenitiesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.hotels.checkInDate}
        label={'Dates de début votre séjour ? (même approximatives)'}
        let:field
    >
        <DatePickerInput futureDateOnly {field} {form} {...dateTimeNullable} />
    </Row>

    <Row
        {form}
        field={fields.hotels.checkOutDate}
        label={'Date de fin de votre séjour ?'}
        let:field
    >
        <DatePickerInput futureDateOnly {field} {form} {...dateTimeNullable} />
    </Row>

    <Row
        {form}
        field={fields.hotels.hotelRating}
        class=""
        let:field
        let:id
        label={`Gamme de l'hôtel`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[300px]:grid-cols-2 @[500px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={hotelRatingOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
